import URLListener from './URLListener';

// to do: test code, js to be written by DNS

(() => {
    const showAllButton = document.querySelector('[data-suggested-registrars-show-all-button]');
    const showAllContainer = document.querySelector('[data-suggested-registrars-show-all-container]');
    const suggestedRegistrars = document.querySelector('[data-suggested-registrars]');

    if (!showAllButton || !showAllContainer) {
        return;
    }

    showAllButton.addEventListener('click', () => {
        showAllContainer.classList.add('is-hidden');
        suggestedRegistrars.classList.remove('is-collapsed');
    });
})();

(() => {
    const specialCharButton = document.querySelector('.lookup-widget__special');
    const keyboard = document.querySelector('.lookup-widget__keyboard');

    if (specialCharButton) {
        specialCharButton.addEventListener('click', () => {
            specialCharButton.classList.toggle('is-active');
            keyboard.classList.toggle('is-open');
        });
    }
})();

(() => {
    const lookupList = document.querySelector('.lookup-list');
    const lookupButton = document.querySelector('.lookup-widget__button');

    if (lookupButton && lookupList) {
        lookupButton.addEventListener('click', (event) => {
            event.preventDefault();
            lookupList.classList.toggle('is-open');
        });
    }
})();

const urlListener = new URLListener();
urlListener.init();
